import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { postBidderConsent } from '@/redux/api/bidder';

/* Action Types */
export const SUBMIT_CONSENT_FAIL = 'la/ui/consent/FAIL';
export const SUBMIT_CONSENT_REQUEST = 'la/ui/consent/REQUEST';
export const SUBMIT_CONSENT_SUCCESS = 'la/ui/consent/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SUBMIT_CONSENT_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false,
            };
        case SUBMIT_CONSENT_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: true,
                success: false,
            };
        case SUBMIT_CONSENT_SUCCESS:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.consent;

export const getUiConsent = createSelector(stateSelector, (state) => state);

/* ACTION CREATORS */
export const submitConsent = (consent: any, context: any) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: SUBMIT_CONSENT_REQUEST,
        });
        await postBidderConsent({ authToken, consent, context, deployment });
        dispatch({
            meta: {
                actionTime: Date.now(),
            },
            payload: 'accepted',
            type: SUBMIT_CONSENT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: SUBMIT_CONSENT_FAIL,
        });
    }
};
